import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.medium}33;
  background: ${({ theme }) => theme.palette.neutral.darkest};
  flex-shrink: 0;
`;

export const BaseButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border: none;
  border-radius: 1rem;
  transition: background-color 0.3s ease;
  margin-bottom: 0.75rem;
  cursor: pointer;

  span {
    font-weight: 600;
    font-size: 1rem;
  }
`;

export const PrimaryButton = styled(BaseButton)`
  background: ${({ theme }) => theme.palette.primary.medium};

  &:hover {
    background: ${({ theme }) => theme.palette.primary.medium};
  }

  span {
    color: white;
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background: ${({ theme }) => `${theme.palette.neutral.lightest}1A`};

  &:hover {
    background: ${({ theme }) => `${theme.palette.neutral.lightest}33`};
  }

  span {
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }
`;

export const IconWrapperPrimary = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1rem;
    height: 1rem;
    color: white;
  }
`;

export const IconWrapperSecondary = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.75rem;
  background: ${({ theme }) => `${theme.palette.primary.medium}33`};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1rem;
    height: 1rem;
    color: ${({ theme }) => theme.palette.primary.medium};
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;

  a {
    color: ${({ theme }) => `${theme.palette.neutral.lightest}99`};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.palette.neutral.lightest};
    }
  }
`;
